import {createAction, props} from '@ngrx/store';
import {DcpNetNewTermsConditions} from '../../../model/dcp-terms-and-conditions';
import {CanonicalId} from '@dcp/configurator';
import {HttpErrorResponse} from '@angular/common/http';
import {DcpTemplateTermsConditionsData} from '../../../model/terms-conditions/dcp-template-terms-conditions-data';

const get = createAction(
  '[TermsAndConditions] Get',
  props<{ canonicalId: CanonicalId; payload?: DcpTemplateTermsConditionsData }>()
);
const load = createAction(
  '[TermsAndConditions] Load',
  props<{ canonicalId: CanonicalId; payload?: DcpTemplateTermsConditionsData }>()
);
const loaded = createAction(
  '[TermsAndConditions] Loaded',
  props<{ termsAndConditions: DcpNetNewTermsConditions[]; canonicalId: CanonicalId }>()
);
const initMap = createAction(
  '[TermsAndConditions] Initialize Map',
  props<{ canonicalId: CanonicalId }>()
);
const loadFailure = createAction(
  '[TermsAndConditions] Call Failed',
  props<{ error: HttpErrorResponse; canonicalId: CanonicalId }>()
);
const setLoadingState = createAction(
  '[TermsAndConditions] Set Loading State',
  props<{ canonicalId: CanonicalId }>()
);
const resetMap = createAction(
  '[TermsAndConditions] Reset Map',
  props<{ canonicalId: CanonicalId }>()
);

export const TermsAndConditionsActions = {
  get,
  load,
  loaded,
  loadFailure,
  initMap,
  setLoadingState,
  resetMap,
};
